import React from 'react';
import { Activity, ActivityType, BuildMethod } from '../../../models/Activity';
import LiveTrainingUpdateForm from './LiveTrainingUpdateForm';
import EditQuestionnaireForm from './activityForms/editActivityForms/EditQuestionnaireForm';
import EditAudioTaskForm from './activityForms/editActivityForms/EditAudioTaskForm';
import EditTextImageTaskForm from './activityForms/editActivityForms/EditTextImageTaskForm';
import EditVideoTaskForm from './activityForms/editActivityForms/EditVideoTaskForm';
import EditPresentationSlideForm from './activityForms/presentationActivities/EditPresentationSlideForm';

type EditActivityComponentProps = {
    returnToCourseStructure: () => void;
    activity: Activity;
};

export default function EditActivityComponent({
    returnToCourseStructure,
    activity,
}: EditActivityComponentProps): JSX.Element {
    switch (activity.type) {
        case ActivityType.QUESTIONNAIRE:
            return (
                <EditQuestionnaireForm questionnaire={activity} returnToCourseStructure={returnToCourseStructure} />
            );
        case ActivityType.LIVE_TRAINING:
            return <LiveTrainingUpdateForm activity={activity} returnToCourseStructure={returnToCourseStructure} />;
        case ActivityType.PRESENTATION_SLIDE:
            return <EditPresentationSlideForm slide={activity} returnToCourseStructure={returnToCourseStructure} />;
        case ActivityType.TASK:
        default:
            switch (activity.buildMethod) {
                case BuildMethod.AUDIO:
                    return <EditAudioTaskForm task={activity} returnToCourseStructure={returnToCourseStructure} />;
                case BuildMethod.VIDEO:
                    return <EditVideoTaskForm task={activity} returnToCourseStructure={returnToCourseStructure} />;
                case BuildMethod.TEXT_AND_IMAGE:
                default:
                    return (
                        <EditTextImageTaskForm
                            task={activity}
                            returnToCourseStructure={returnToCourseStructure}
                        />
                    );
            }
    }
}
